import { render, staticRenderFns } from "./emptySwitchAgentLevel2List.vue?vue&type=template&id=463b59fa&scoped=true"
import script from "./emptySwitchAgentLevel2List.vue?vue&type=script&lang=js"
export * from "./emptySwitchAgentLevel2List.vue?vue&type=script&lang=js"
import style0 from "./emptySwitchAgentLevel2List.vue?vue&type=style&index=0&id=463b59fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b59fa",
  null
  
)

export default component.exports